import { createAction } from "redux-starter-kit";
import { OPEN_EDIT_LINEITEM } from "../types";

const openEditLineItem = (id, data) => createAction(OPEN_EDIT_LINEITEM)({ id, data });

export default openEditLineItem;
